import React from "react";

import { useTranslation } from "react-i18next";

import Fade from 'react-reveal/Fade';

import trade from '../../img/trade.png'

function HowDoes () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[120px]">
            <div className="xl:h-[127px] bg-[#9D0032] flex flex-col xl:flex-row justify-between px-[20px] xl:px-[30px] py-[20px] items-center">
                <p className="text-white manrope text-[20px] xl:text-[35px] font-[500] text-center xl:text-start max-w-[350px] leading-[1.2]">{t('home.24')}</p>
                <p className="roboto text-white font-[300] text-[14px] xl:max-w-[500px] text-center xl:text-start mt-[20px] xl:mt-0">{t('home.25')}</p>
            </div>
            <div className="grid gap-[20px] grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-[20px] xl:mt-[40px]">
                <div>
                    <div className="flex items-center gap-[10px] md:gap-[20px]">
                        <div className="w-[20px] xl:w-[32px] h-[20px] xl:h-[32px] flex items-center justify-center bg-[#9D0032] roboto text-[14px] font-[500] text-white">1</div>
                        <p className="roboto font-[500] text-[14px]">{t('home.26')}</p>
                    </div>
                    <p className="mt-[10px] roboto text-[14px] font-[300] text-[#000000B2] xl:max-w-[391px]">{t('home.27')}</p>
                </div>
                <div>
                    <div className="flex items-center gap-[10px] md:gap-[20px]">
                        <div className="w-[20px] xl:w-[32px] h-[20px] xl:h-[32px] flex items-center justify-center bg-[#9D0032] roboto text-[14px] font-[500] text-white">2</div>
                        <p className="roboto font-[500] text-[14px]">{t('home.29')}</p>
                    </div>
                    <p className="mt-[10px] roboto text-[14px] font-[300] text-[#000000B2] xl:max-w-[391px]">{t('home.28')}</p>
                </div>
                <div>
                    <div className="flex items-center gap-[10px] md:gap-[20px]">
                        <div className="w-[20px] xl:w-[32px] h-[20px] xl:h-[32px] flex items-center justify-center bg-[#9D0032] roboto text-[14px] font-[500] text-white">3</div>
                        <p className="roboto font-[500] text-[14px]">{t('home.30')}</p>
                    </div>
                    <p className="mt-[10px] roboto text-[14px] font-[300] text-[#000000B2] xl:max-w-[391px]">{t('home.31')}</p>
                </div>
                <div>
                    <div className="flex items-center gap-[10px] md:gap-[20px]">
                        <div className="w-[20px] xl:w-[32px] h-[20px] xl:h-[32px] flex items-center justify-center bg-[#9D0032] roboto text-[14px] font-[500] text-white">4</div>
                        <p className="roboto font-[500] text-[14px]">{t('home.32')}</p>
                    </div>
                    <p className="mt-[10px] roboto text-[14px] font-[300] text-[#000000B2] xl:max-w-[391px]">{t('home.33')}</p>
                </div>
                <div>
                    <div className="flex items-center gap-[10px] md:gap-[20px]">
                        <div className="w-[20px] xl:w-[32px] h-[20px] xl:h-[32px] flex items-center justify-center bg-[#9D0032] roboto text-[14px] font-[500] text-white">5</div>
                        <p className="roboto font-[500] text-[14px]">{t('home.34')}</p>
                    </div>
                    <p className="mt-[10px] roboto text-[14px] font-[300] text-[#000000B2] xl:max-w-[391px]">{t('home.35')}</p>
                </div>
            </div>
        </div>
    );
}

export default HowDoes;